/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import melodicoImg from '../../../imgs/artists/melodico_img.jpg';
import donAeroImg from '../../../imgs/artists/don_aero_img.jpg';
import swatImg from '../../../imgs/artists/swat_img.jpg';
import dubGImg from '../../../imgs/artists/dub-g_img.jpg';
import oscarCImg from '../../../imgs/artists/Oscar_C_img.jpg';
import ckanImg from '../../../imgs/artists/c_kan_img.jpg';

export const artistsData = {
  melodico: {
    slug: 'melodico',
    path: '/melodico',
    name: 'Melódico',
    displayFirst: 'Meló',
    displayItalic: 'dico',
    portrait: melodicoImg,
    appleArtistId: '464785275',
    city: 'Chile',
    genre: 'R&B',
    year: '2015',
    handle: '@melodico',
    tagline: 'El poeta urbano que convirtió el silencio en canción.',
    bioLead:
      'Desde pequeño, Carlos Osses sabía que su futuro sería la música. Criado sin sus padres, bajo la custodia de su abuela, usaba lápiz y papel para desahogar sus sentimientos. Apenas tenía ocho años y ya había aprendido lo duro que es sobrevivir, al ver a su abuela trabajar en las calles de su natal Chile para poner el pan diario en la mesa.',
    bioMore: [
      '"Mi abuela como podía me mantenía, había muchas necesidades en ese tiempo y esas carencias fueron las que me llevaron a crear un futuro en el cual todo estaría mejor", explica. "Hablaba de lo que me hacía falta, de venir de raíces humildes, de mi deseo por tener una familia y sobresalir".',
      'Hoy por hoy, Carlos, mejor conocido como Melódico, disfruta de lo que su enfoque y esfuerzo han sembrado dentro del género urbano. Bajo el sello de Mastered Trax, establece el estándar para la nueva generación de artistas urbanos que colaboran para el crecimiento del género.',
      'Sus letras buscan exponer la realidad de los menos afortunados, las experiencias de los corazones rotos y enamorados, y a la vez desahogar su sentir. "Es un placer trabajar en lo que me gusta", comenta Melódico.',
      '"He aprendido a valorar no sólo las cosas materiales, sino a la familia y todo lo que me rodea", dice. "Esto no es un trabajo para mí, sigo creyendo que nada más estoy haciendo lo que me gusta."',
    ],
    socials: {
      instagram: 'https://www.instagram.com/melodico',
      facebook: 'https://www.facebook.com/melodico',
      youtube: 'https://www.youtube.com/user/MelodicoVEVO',
      spotify: 'https://open.spotify.com/artist/0S6XZyWww6AyEUfk62wRJg',
      apple: 'https://music.apple.com/us/artist/melodico/464785275',
    },
    youtubeEmbed: 'adj1jpQ4aMk',
    spotifyEmbed: 'https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO0s5tps?utm_source=generator&theme=0',
    booking: 'joe@masteredtrax.com',
  },

  donaero: {
    slug: 'donaero',
    path: '/donaero',
    name: 'Don Aero',
    displayFirst: 'Don',
    displayItalic: 'Aero',
    portrait: donAeroImg,
    appleArtistId: '431764834',
    city: 'Tijuana, MX',
    genre: 'Hip-Hop',
    year: '2017',
    handle: '@donaerohiphop',
    tagline: 'Pluma tapatia y precisión lírica — una voz que nunca pide permiso.',
    bioLead:
      'En 1999 Don Aero toma el papel y la tinta para pintar ideas, dando inicio a su trayectoria utilizando los recursos de la web — descargando tracks instrumentales de productores reconocidos. Para el año 2000 graba su primer material en cassette titulado "Aerodinámico", que sólo fue distribuido entre amigos y conocidos.',
    bioMore: [
      'En 2001 se forma el grupo Soxiedad Anónima junto a Iofeck y Vocal, y años más tarde se integra Sicko. Este proyecto permaneció vigente varios años y abrió muchas puertas para el hip hop en Tijuana, siendo uno de los primeros grupos que movilizara el género.',
      'Tras la separación del grupo en 2006, Don Aero decide lanzar su primer material discográfico titulado "Súbele Volumen", con el que dió inicio a una trayectoria musical como solista. En 2008 vuelve con "REVOLVER", una gran consolidación de un nuevo estilo musical con ritmos agresivos y un estilo lírico muy peculiar.',
      'El rapero tijuanense firma con Mastered Trax, sello que se encarga de la promoción del cantante en sus próximos proyectos como solista. Se augura un próximo hit internacional con su nuevo material discográfico titulado "De Boca en Boca".',
    ],
    socials: {
      instagram: 'https://www.instagram.com/donaerohiphop/',
      facebook: 'https://www.facebook.com/donaerohiphop',
      youtube: 'https://www.youtube.com/channel/UCaEZ1OAjebcZOnVcNhBZrZQ',
      spotify: 'https://open.spotify.com/artist/2EkFEL5IvD2W8hpwbjS9yv',
      apple: 'https://music.apple.com/us/artist/don-aero/431764834',
    },
    youtubeEmbed: 'Sxq-TYHiS5c',
    spotifyEmbed: 'https://open.spotify.com/embed/playlist/37i9dQZF1DZ06evO1wp2IU?utm_source=generator&theme=0',
    booking: 'joe@masteredtrax.com',
  },

  swat: {
    slug: 'swat',
    path: '/swat',
    name: 'SWAT',
    displayFirst: 'S',
    displayItalic: 'WAT',
    portrait: swatImg,
    appleArtistId: '145013042',
    city: 'Guadalajara, MX',
    genre: 'Rap',
    year: '2018',
    handle: '@swat_c_mobztas',
    tagline: 'Tapatío de sangre, escrito en calles y salones llenos.',
    bioLead:
      'Víctor Alfonso Vivas Lozano, mejor conocido como "SWAT", rapero y compositor tapatío nacido en Guadalajara, Jalisco el 12 de Julio de 1984. Comenzó en la música bajo el sello de Mastered Trax con su disco titulado "Sin Tanto Alarde".',
    bioMore: [
      'Trabaja también como backup y Road Manager del rapero C-Kan. Ha colaborado en discos como "The Take Over" Volumen 1 y 2 en canciones como "Qué Les Preocupa" y "Estado Mental", así como en el disco "Mexickanos" de C-Kan en "Guadalajara", "Click Clack" y "Darles".',
      'Ha participado en eventos masivos de música urbana como el "Urban Fest" del Auditorio Benito Juárez, así como eventos de Hip-Hop y Rap dentro y fuera de México en países como USA, Argentina y Ecuador.',
      'Cuenta con colaboraciones con artistas reconocidos como C-Kan, MC Magic, Baby Bash, Don Aero, Neztor MVL y TM Zaico, entre otros. Entre sus más de 10 videos musicales en YouTube destacan "Mobz in da Hood" feat. C-Kan y "Party Like a Mobzta" feat. MC Magic.',
    ],
    socials: {
      instagram: 'https://www.instagram.com/swat_c_mobztas/',
      facebook: 'https://www.facebook.com/SWATCMOB/',
      youtube: 'https://www.youtube.com/@swatcmobztas8014',
      spotify: 'https://open.spotify.com/artist/62Wx8Zm0z41Lw5kgmJKpRF',
      apple: 'https://music.apple.com/us/artist/swat/145013042',
    },
    youtubeEmbed: 'ex4R-TeekxU',
    spotifyEmbed: 'https://open.spotify.com/embed/artist/62Wx8Zm0z41Lw5kgmJKpRF?utm_source=generator&theme=0',
    booking: 'swat@masteredtrax.com',
  },

  dubg: {
    slug: 'dubg',
    path: '/dubg',
    name: 'Dub-G',
    displayFirst: 'Dub',
    displayItalic: '-G',
    portrait: dubGImg,
    appleArtistId: '1516125207',
    city: 'Guadalajara, MX',
    genre: 'Rap · Trap',
    year: '2020',
    handle: '@dubskillaz',
    tagline: 'Un puente entre el trap en inglés y el rap en español — sin acento, sin permiso.',
    bioLead:
      'Dub G is a dynamic rap artist who seamlessly bridges the gap between English trap and Spanish rap, crafting a sound uniquely his own. With an innate talent for storytelling and a deep connection to his Mexican heritage, Dub G has emerged as a powerful voice in the rap scene.',
    bioMore: [
      "From a young age, Dub G was surrounded by music. While his early exposure leaned towards English trap, a pivotal moment came when he discovered the potential of rap in Spanish. The vibrant Mexican rap scene ignited his creativity, inspiring him to fuse his linguistic prowess with his passion for rap.",
      "His songwriting is an unfiltered reflection of his life's journey, capturing every high and low, every triumph and struggle. His music becomes a canvas where he paints his experiences, allowing listeners to connect on a deeply personal level.",
      'Dub G\'s lyrical compositions serve as windows into the issues of his community. His focus is on delivering good, relatable music that resonates with listeners on a personal level — captivating and uniting diverse audiences through the universal language of music.',
    ],
    socials: {
      instagram: 'https://www.instagram.com/dubskillaz/',
      youtube: 'https://www.youtube.com/channel/UCX_Ymdf_bsVEoP6BpZOGV0Q',
      spotify: 'https://open.spotify.com/artist/5SVHvnw9UIDoLNC745Lt8V',
      apple: 'https://music.apple.com/us/artist/dub-g/1516125207',
    },
    youtubeEmbed: 'qpgL5VPDc0g',
    spotifyEmbed: 'https://open.spotify.com/embed/artist/5SVHvnw9UIDoLNC745Lt8V?utm_source=generator&theme=0',
    booking: 'joe@masteredtrax.com',
  },

  oscarc: {
    slug: 'oscarc',
    path: '/oscarc',
    name: 'Oscar Calderón',
    displayFirst: 'Oscar',
    displayItalic: 'Calderón',
    portrait: oscarCImg,
    city: 'Chihuahua, MX',
    genre: 'Pop · Urbano · Regional',
    year: '2021',
    handle: '@OscarCalderonMx',
    tagline: 'Virtuosismo vocal y oficio de autor — entre el regional y la balada urbana.',
    bioLead:
      'Oscar Calderón comenzó su carrera musical a los 10 años subiendo canciones a YouTube, canal que se popularizó rápidamente y que, debido al éxito, lo llevó a grabar comerciales para radio impulsando su experiencia profesional.',
    bioMore: [
      'Más adelante comienza un proyecto a dueto, lanzando en 2016 su primer EP compuesto por 4 canciones recibidas con gran aceptación del público. Cuenta con sencillos dentro de la agrupación y diversos shows abriendo conciertos de artistas como Flans y Kalimba.',
      'Gracias a su virtuosismo vocal, participó como corista de Juan Gabriel, Prince Royce, Emmanuel, Flans, Daniel Boaventura, Eugenia León, Ana Bárbara, entre muchos otros. Experiencia que lo llevó a firmar con Ark Records como artista solista; lanzando bajo el sello los sencillos "La Faldita", "Si Fuera Por Mí", "Si Tú Me Dejas" y "La Receta".',
      'De forma independiente produjo y compuso canciones para artistas como Edith Marquez, Kalimba, Alex Durán y Fabiola Guajardo. En 2022 lanza su propio sello OC Records y actualmente prepara su nuevo sencillo regional-urbano "Con Eso es Suficiente".',
    ],
    socials: {
      instagram: 'https://www.instagram.com/oscarcalderonmx/',
      facebook: 'https://www.facebook.com/oscarcalderonmx',
      youtube: 'https://www.youtube.com/channel/UCPblXiMJbfHIWLnTPj18ppg',
    },
    youtubeEmbed: 'zXDMt0YsbUg',
    spotifyEmbed: 'https://open.spotify.com/embed/artist/3s1IP7QMBQxcsCKwUi86iG?utm_source=generator&theme=0',
    booking: 'joe@masteredtrax.com',
  },
};

export const rosterList = [
  {
    name: 'C-Kan',
    portrait: ckanImg,
    city: 'Guadalajara, MX',
    year: '2011',
    genre: 'Hip-Hop',
    external: true,
    path: 'https://ckan.mx',
  },
  { ...artistsData.melodico, external: false },
  { ...artistsData.donaero, external: false },
  { ...artistsData.swat, external: false },
  { ...artistsData.dubg, external: false },
  { ...artistsData.oscarc, external: false },
];
